import { I18n } from '@calendly/i18n';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { Link } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { WidgetContainer } from './widget_container';
const PROVIDERS_LOGOS = {
  stripe: 'stripe',
  paypal: 'pay-pal'
};
const contentCss = "ccbzy8v";
const Content = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(contentCss, props.className)} />);
const containerCss = "c1pgfi4e";
const Container = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const providerLogoCss = "p18z2dl2";
const ProviderLogo = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(providerLogoCss, props.className)} />);
const textContentCss = "tguj2ps";
const TextContent = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(textContentCss, props.className)} />);
export const PaymentWidget = ({
  event
}) => {
  const {
    invitee
  } = event;
  if (!invitee) return null;
  const {
    charge
  } = invitee;
  if (!charge) return null;
  if (!charge.captured) return null;
  const info = I18n.t('publisher.dashboard.invitee.paid_via', {
    amount_with_symbol: charge.amountWithSymbol,
    currency: charge.currency,
    provider_name: charge.providerName
  });
  const couponInfo = charge.bookingCodeInfo ? I18n.t('publisher.dashboard.invitee.booking_code_used', {
    code: charge.bookingCodeInfo.code,
    discount_with_symbol: charge.bookingCodeInfo.bookingCodeType === 'FIXED' ? charge.bookingCodeInfo.discountValueWithSymbol : `${charge.bookingCodeInfo.percentOff}%`
  }) : null;
  const showTransactionLink = Boolean(charge.amount && charge.externalChargeLink);
  return <WidgetContainer title={I18n.t('publisher.meetings.payment.title')} showBorder={false} sectionWithBottomBorder noPadding>
      <Content>
        <Container>
          <ProviderLogo>
            <BrandLogo name={PROVIDERS_LOGOS[charge.provider]} />
          </ProviderLogo>
          <TextContent>
            <BodyText weight="bold">
              {info}
            </BodyText>
            {couponInfo && <BodyText weight="standard">
              {couponInfo}
            </BodyText>}
          </TextContent>
        </Container>
        {showTransactionLink && <BodyText size="small" weight="semibold" color={colorTextAction}>
          <Link href={charge.externalChargeLink} target="_blank" rel="noopener noreferrer" underline={false}>
            {I18n.t('publisher.meetings.payment.view')}
          </Link>
        </BodyText>}
      </Content>
    </WidgetContainer>;
};

require("./payment_widget.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_widget.js");